export const recoveryOfRentFeeCondition = [
  {
    state: "Delhi and Chandigarh",
    condition: [
      { valueOfProperty: "0,5", courtFees: "0.5" },
      { valueOfProperty: "5,10", courtFees: "1.0" },
      { valueOfProperty: "10,15", courtFees: "1.5" },
      { valueOfProperty: "15,20", courtFees: "2.0" },
      { valueOfProperty: "20,25", courtFees: "2.5" },
      { valueOfProperty: "25,30", courtFees: "3.0" },
      { valueOfProperty: "30,35", courtFees: "3.5" },
      { valueOfProperty: "35,40", courtFees: "4.0" },
      { valueOfProperty: "40,45", courtFees: "4.5" },
      { valueOfProperty: "45,50", courtFees: "5.0" },
      { valueOfProperty: "50,55", courtFees: "5.5" },
      { valueOfProperty: "55,60", courtFees: "6.0" },
      { valueOfProperty: "60,65", courtFees: "6.5" },
      { valueOfProperty: "65,70", courtFees: "7.0" },
      { valueOfProperty: "70,75", courtFees: "7.5" },
      { valueOfProperty: "75,80", courtFees: "8.0" },
      { valueOfProperty: "80,85", courtFees: "8.5" },
      { valueOfProperty: "85,90", courtFees: "9.0" },
      { valueOfProperty: "90,95", courtFees: "9.5" },
      { valueOfProperty: "95,100", courtFees: "10.0" },
      { valueOfProperty: "100,110", courtFees: "11.0" },
      { valueOfProperty: "110,120", courtFees: "12.0" },
      { valueOfProperty: "120,130", courtFees: "13.0" },
      { valueOfProperty: "130,140", courtFees: "14.0" },
      { valueOfProperty: "140,150", courtFees: "15.0" },
      { valueOfProperty: "150,160", courtFees: "16.0" },
      { valueOfProperty: "160,170", courtFees: "17.0" },
      { valueOfProperty: "170,180", courtFees: "18.0" },
      { valueOfProperty: "180,190", courtFees: "19.0" },
      { valueOfProperty: "190,200", courtFees: "20.0" },
      { valueOfProperty: "200,210", courtFees: "21.0" },
      { valueOfProperty: "210,220", courtFees: "22.0" },
      { valueOfProperty: "220,230", courtFees: "23.0" },
      { valueOfProperty: "230,240", courtFees: "24.0" },
      { valueOfProperty: "240,250", courtFees: "25.0" },
      { valueOfProperty: "250,260", courtFees: "26.0" },
      { valueOfProperty: "260,270", courtFees: "27.0" },
      { valueOfProperty: "270,280", courtFees: "28.0" },
      { valueOfProperty: "280,290", courtFees: "29.0" },
      { valueOfProperty: "290,300", courtFees: "30.0" },
      { valueOfProperty: "300,310", courtFees: "31.0" },
      { valueOfProperty: "310,320", courtFees: "32.0" },
      { valueOfProperty: "320,330", courtFees: "33.0" },
      { valueOfProperty: "330,340", courtFees: "34.0" },
      { valueOfProperty: "340,350", courtFees: "35.0" },
      { valueOfProperty: "350,360", courtFees: "36.0" },
      { valueOfProperty: "360,370", courtFees: "37.0" },
      { valueOfProperty: "370,380", courtFees: "38.0" },
      { valueOfProperty: "380,390", courtFees: "39.0" },
      { valueOfProperty: "390,400", courtFees: "40.0" },
      { valueOfProperty: "400,410", courtFees: "41.0" },
      { valueOfProperty: "410,420", courtFees: "42.0" },
      { valueOfProperty: "420,430", courtFees: "43.0" },
      { valueOfProperty: "430,440", courtFees: "44.0" },
      { valueOfProperty: "440,450", courtFees: "45.0" },
      { valueOfProperty: "450,460", courtFees: "46.0" },
      { valueOfProperty: "460,470", courtFees: "47.0" },
      { valueOfProperty: "470,480", courtFees: "48.0" },
      { valueOfProperty: "480,490", courtFees: "49.0" },
      { valueOfProperty: "490,500", courtFees: "50.0" },
      { valueOfProperty: "500,510", courtFees: "76.5" },
      { valueOfProperty: "510,520", courtFees: "78.0" },
      { valueOfProperty: "520,530", courtFees: "79.5" },
      { valueOfProperty: "530,540", courtFees: "81.0" },
      { valueOfProperty: "540,550", courtFees: "82.5" },
      { valueOfProperty: "550,560", courtFees: "84.0" },
      { valueOfProperty: "560,570", courtFees: "85.5" },
      { valueOfProperty: "570,580", courtFees: "87.0" },
      { valueOfProperty: "580,590", courtFees: "88.5" },
      { valueOfProperty: "590,600", courtFees: "90.0" },
      { valueOfProperty: "600,610", courtFees: "91.5" },
      { valueOfProperty: "610,620", courtFees: "93.0" },
      { valueOfProperty: "620,630", courtFees: "94.5" },
      { valueOfProperty: "630,640", courtFees: "96.0" },
      { valueOfProperty: "640,650", courtFees: "97.5" },
      { valueOfProperty: "650,660", courtFees: "99.0" },
      { valueOfProperty: "660,670", courtFees: "100.5" },
      { valueOfProperty: "670,680", courtFees: "102.0" },
      { valueOfProperty: "680,690", courtFees: "103.5" },
      { valueOfProperty: "690,700", courtFees: "105.0" },
      { valueOfProperty: "700,710", courtFees: "106.5" },
      { valueOfProperty: "710,720", courtFees: "108.0" },
      { valueOfProperty: "720,730", courtFees: "109.5" },
      { valueOfProperty: "730,740", courtFees: "111.0" },
      { valueOfProperty: "740,750", courtFees: "112.5" },
      { valueOfProperty: "750,760", courtFees: "114.0" },
      { valueOfProperty: "760,770", courtFees: "115.5" },
      { valueOfProperty: "770,780", courtFees: "117.0" },
      { valueOfProperty: "780,790", courtFees: "118.5" },
      { valueOfProperty: "790,800", courtFees: "120.0" },
      { valueOfProperty: "800,810", courtFees: "121.5" },
      { valueOfProperty: "810,820", courtFees: "123.0" },
      { valueOfProperty: "820,830", courtFees: "124.5" },
      { valueOfProperty: "830,840", courtFees: "126.0" },
      { valueOfProperty: "840,850", courtFees: "127.5" },
      { valueOfProperty: "850,860", courtFees: "129.0" },
      { valueOfProperty: "860,870", courtFees: "130.5" },
      { valueOfProperty: "870,880", courtFees: "132.0" },
      { valueOfProperty: "880,890", courtFees: "133.5" },
      { valueOfProperty: "890,900", courtFees: "135.0" },
      { valueOfProperty: "900,910", courtFees: "136.5" },
      { valueOfProperty: "910,920", courtFees: "138.0" },
      { valueOfProperty: "920,930", courtFees: "139.5" },
      { valueOfProperty: "930,940", courtFees: "141.0" },
      { valueOfProperty: "940,950", courtFees: "142.5" },
      { valueOfProperty: "950,960", courtFees: "144.0" },
      { valueOfProperty: "960,970", courtFees: "145.5" },
      { valueOfProperty: "970,980", courtFees: "147.0" },
      { valueOfProperty: "980,990", courtFees: "148.5" },
      { valueOfProperty: "990,1000", courtFees: "150.0" },
      { valueOfProperty: "1000,1100", courtFees: "162.2" },
      { valueOfProperty: "1100,1200", courtFees: "174.4" },
      { valueOfProperty: "1200,1300", courtFees: "186.6" },
      { valueOfProperty: "1300,1400", courtFees: "198.8" },
      { valueOfProperty: "1400,1500", courtFees: "211.0" },
      { valueOfProperty: "1500,1600", courtFees: "223.2" },
      { valueOfProperty: "1600,1700", courtFees: "235.4" },
      { valueOfProperty: "1700,1800", courtFees: "247.6" },
      { valueOfProperty: "1800,1900", courtFees: "259.8" },
      { valueOfProperty: "1900,2000", courtFees: "272.0" },
      { valueOfProperty: "2000,2100", courtFees: "284.2" },
      { valueOfProperty: "2100,2200", courtFees: "296.4" },
      { valueOfProperty: "2200,2300", courtFees: "308.6" },
      { valueOfProperty: "2300,2400", courtFees: "320.8" },
      { valueOfProperty: "2400,2500", courtFees: "333.0" },
      { valueOfProperty: "2500,2600", courtFees: "345.2" },
      { valueOfProperty: "2600,2700", courtFees: "357.4" },
      { valueOfProperty: "2700,2800", courtFees: "369.6" },
      { valueOfProperty: "2800,2900", courtFees: "381.8" },
      { valueOfProperty: "2900,3000", courtFees: "394.0" },
      { valueOfProperty: "3000,3100", courtFees: "406.2" },
      { valueOfProperty: "3100,3200", courtFees: "418.4" },
      { valueOfProperty: "3200,3300", courtFees: "430.6" },
      { valueOfProperty: "3300,3400", courtFees: "442.8" },
      { valueOfProperty: "3400,3500", courtFees: "455.0" },
      { valueOfProperty: "3500,3600", courtFees: "467.2" },
      { valueOfProperty: "3600,3700", courtFees: "479.4" },
      { valueOfProperty: "3700,3800", courtFees: "491.6" },
      { valueOfProperty: "3800,3900", courtFees: "503.8" },
      { valueOfProperty: "3900,4000", courtFees: "516.0" },
      { valueOfProperty: "4000,4100", courtFees: "528.2" },
      { valueOfProperty: "4100,4200", courtFees: "540.4" },
      { valueOfProperty: "4200,4300", courtFees: "552.6" },
      { valueOfProperty: "4300,4400", courtFees: "564.8" },
      { valueOfProperty: "4400,4500", courtFees: "577.0" },
      { valueOfProperty: "4500,4600", courtFees: "589.2" },
      { valueOfProperty: "4600,4700", courtFees: "601.4" },
      { valueOfProperty: "4700,4800", courtFees: "613.6" },
      { valueOfProperty: "4800,4900", courtFees: "625.8" },
      { valueOfProperty: "4900,5000", courtFees: "638.0" },
      { valueOfProperty: "5000,5250", courtFees: "662.4" },
      { valueOfProperty: "5250,5500", courtFees: "686.8" },
      { valueOfProperty: "5500,5750", courtFees: "711.2" },
      { valueOfProperty: "5750,6000", courtFees: "735.6" },
      { valueOfProperty: "6000,6250", courtFees: "760.0" },
      { valueOfProperty: "6250,6500", courtFees: "784.4" },
      { valueOfProperty: "6500,6750", courtFees: "808.8" },
      { valueOfProperty: "6750,7000", courtFees: "833.2" },
      { valueOfProperty: "7000,7250", courtFees: "857.6" },
      { valueOfProperty: "7250,7500", courtFees: "882.0" },
      { valueOfProperty: "7500,7750", courtFees: "906.4" },
      { valueOfProperty: "7750,8000", courtFees: "930.8" },
      { valueOfProperty: "8000,8250", courtFees: "955.2" },
      { valueOfProperty: "8250,8500", courtFees: "979.6" },
      { valueOfProperty: "8500,8750", courtFees: "1004.0" },
      { valueOfProperty: "8750,9000", courtFees: "1028.4" },
      { valueOfProperty: "9000,9250", courtFees: "1052.8" },
      { valueOfProperty: "9250,9500", courtFees: "1077.2" },
      { valueOfProperty: "9500,9750", courtFees: "1101.6" },
      { valueOfProperty: "9750,10000", courtFees: "1126.0" },
      { valueOfProperty: "10000,10500", courtFees: "1162.5" },
      { valueOfProperty: "10500,11000", courtFees: "1199.0" },
      { valueOfProperty: "11000,11500", courtFees: "1235.5" },
      { valueOfProperty: "11500,12000", courtFees: "1272.0" },
      { valueOfProperty: "12000,12500", courtFees: "1308.5" },
      { valueOfProperty: "12500,13000", courtFees: "1345.0" },
      { valueOfProperty: "13000,13500", courtFees: "1381.5" },
      { valueOfProperty: "13500,14000", courtFees: "1418.0" },
      { valueOfProperty: "14000,14500", courtFees: "1454.5" },
      { valueOfProperty: "14500,15000", courtFees: "1491.0" },
      { valueOfProperty: "15000,15500", courtFees: "1527.5" },
      { valueOfProperty: "15500,16000", courtFees: "1564.0" },
      { valueOfProperty: "16000,16500", courtFees: "1600.5" },
      { valueOfProperty: "16500,17000", courtFees: "1637.0" },
      { valueOfProperty: "17000,17500", courtFees: "1673.5" },
      { valueOfProperty: "17500,18000", courtFees: "1710.0" },
      { valueOfProperty: "18000,18500", courtFees: "1746.5" },
      { valueOfProperty: "18500,19000", courtFees: "1783.0" },
      { valueOfProperty: "19000,19500", courtFees: "1819.5" },
      { valueOfProperty: "19500,20000", courtFees: "1856.0" },
      { valueOfProperty: "20000,21000", courtFees: "1904.8" },
      { valueOfProperty: "21000,22000", courtFees: "1953.6" },
      { valueOfProperty: "22000,23000", courtFees: "2002.4" },
      { valueOfProperty: "23000,24000", courtFees: "2051.2" },
      { valueOfProperty: "24000,25000", courtFees: "2100.0" },
      { valueOfProperty: "25000,26000", courtFees: "2148.8" },
      { valueOfProperty: "26000,27000", courtFees: "2197.6" },
      { valueOfProperty: "27000,28000", courtFees: "2246.4" },
      { valueOfProperty: "28000,29000", courtFees: "2295.2" },
      { valueOfProperty: "29000,30000", courtFees: "2344.0" },
      { valueOfProperty: "30000,32000", courtFees: "2392.8" },
      { valueOfProperty: "32000,34000", courtFees: "2441.6" },
      { valueOfProperty: "34000,36000", courtFees: "2490.4" },
      { valueOfProperty: "36000,38000", courtFees: "2539.2" },
      { valueOfProperty: "38000,40000", courtFees: "2588.0" },
      { valueOfProperty: "40000,42000", courtFees: "2636.8" },
      { valueOfProperty: "42000,44000", courtFees: "2685.6" },
      { valueOfProperty: "44000,46000", courtFees: "2734.4" },
      { valueOfProperty: "46000,48000", courtFees: "2783.2" },
      { valueOfProperty: "48000,50000", courtFees: "2832.0" },
      { valueOfProperty: "50000,55000", courtFees: "2880.8" },
      { valueOfProperty: "55000,60000", courtFees: "2929.6" },
      { valueOfProperty: "60000,65000", courtFees: "2978.4" },
      { valueOfProperty: "65000,70000", courtFees: "3027.2" },
      { valueOfProperty: "70000,75000", courtFees: "3076.0" },
      { valueOfProperty: "75000,80000", courtFees: "3124.8" },
      { valueOfProperty: "80000,85000", courtFees: "3173.6" },
      { valueOfProperty: "85000,90000", courtFees: "3222.4" },
      { valueOfProperty: "90000,95000", courtFees: "3271.2" },
      { valueOfProperty: "95000,100000", courtFees: "3320.0" },
      { valueOfProperty: "100000,105000", courtFees: "3368.8" },
      { valueOfProperty: "105000,110000", courtFees: "3417.6" },
      { valueOfProperty: "110000,115000", courtFees: "3466.4" },
      { valueOfProperty: "115000,120000", courtFees: "3515.2" },
      { valueOfProperty: "120000,125000", courtFees: "3564.0" },
      { valueOfProperty: "125000,130000", courtFees: "3612.8" },
      { valueOfProperty: "130000,135000", courtFees: "3661.6" },
      { valueOfProperty: "135000,140000", courtFees: "3710.4" },
      { valueOfProperty: "140000,145000", courtFees: "3759.2" },
      { valueOfProperty: "145000,150000", courtFees: "3808.0" },
      { valueOfProperty: "150000,155000", courtFees: "3856.8" },
      { valueOfProperty: "155000,160000", courtFees: "3905.6" },
      { valueOfProperty: "160000,165000", courtFees: "3954.4" },
      { valueOfProperty: "165000,170000", courtFees: "4003.2" },
      { valueOfProperty: "170000,175000", courtFees: "4052.0" },
      { valueOfProperty: "175000,180000", courtFees: "4100.8" },
      { valueOfProperty: "180000,185000", courtFees: "4149.6" },
      { valueOfProperty: "185000,190000", courtFees: "4198.4" },
      { valueOfProperty: "190000,195000", courtFees: "4247.2" },
      { valueOfProperty: "195000,200000", courtFees: "4296.0" },
      { valueOfProperty: "200000,205000", courtFees: "4344.8" },
      { valueOfProperty: "205000,210000", courtFees: "4393.6" },
      { valueOfProperty: "210000,215000", courtFees: "4442.4" },
      { valueOfProperty: "215000,220000", courtFees: "4491.2" },
      { valueOfProperty: "220000,225000", courtFees: "4540.0" },
      { valueOfProperty: "225000,230000", courtFees: "4588.8" },
      { valueOfProperty: "230000,235000", courtFees: "4637.6" },
      { valueOfProperty: "235000,240000", courtFees: "4686.4" },
      { valueOfProperty: "240000,245000", courtFees: "4735.2" },
      { valueOfProperty: "245000,250000", courtFees: "4784.0" },
      { valueOfProperty: "250000,255000", courtFees: "4832.8" },
      { valueOfProperty: "255000,260000", courtFees: "4881.6" },
      { valueOfProperty: "260000,265000", courtFees: "4930.4" },
      { valueOfProperty: "265000,270000", courtFees: "4979.2" },
      { valueOfProperty: "270000,275000", courtFees: "5028.0" },
      { valueOfProperty: "275000,280000", courtFees: "5076.8" },
      { valueOfProperty: "280000,285000", courtFees: "5125.6" },
      { valueOfProperty: "285000,290000", courtFees: "5174.4" },
      { valueOfProperty: "290000,295000", courtFees: "5223.2" },
      { valueOfProperty: "295000,300000", courtFees: "5272.0" },
      { valueOfProperty: "300000,305000", courtFees: "5320.8" },
      { valueOfProperty: "305000,310000", courtFees: "5369.6" },
      { valueOfProperty: "310000,315000", courtFees: "5418.4" },
      { valueOfProperty: "315000,320000", courtFees: "5467.2" },
      { valueOfProperty: "320000,325000", courtFees: "5516.0" },
      { valueOfProperty: "325000,330000", courtFees: "5564.8" },
      { valueOfProperty: "330000,335000", courtFees: "5613.6" },
      { valueOfProperty: "335000,340000", courtFees: "5662.4" },
      { valueOfProperty: "340000,345000", courtFees: "5711.2" },
      { valueOfProperty: "345000,350000", courtFees: "5760.0" },
      { valueOfProperty: "350000,355000", courtFees: "5808.8" },
      { valueOfProperty: "355000,360000", courtFees: "5857.6" },
      { valueOfProperty: "360000,365000", courtFees: "5906.4" },
      { valueOfProperty: "365000,370000", courtFees: "5955.2" },
      { valueOfProperty: "370000,375000", courtFees: "6004.0" },
      { valueOfProperty: "375000,380000", courtFees: "6052.8" },
      { valueOfProperty: "380000,385000", courtFees: "6101.6" },
      { valueOfProperty: "385000,390000", courtFees: "6150.4" },
      { valueOfProperty: "390000,395000", courtFees: "6199.2" },
      { valueOfProperty: "395000,400000", courtFees: "6248.0" },
    ],
  },
  // {
  //   state: "Delhi",
  //   condition: [
  //     { valueOfProperty: "0,5000", courtFees: "0.01*(value)" },
  //     {
  //       valueOfProperty: "5000,20000",
  //       courtFees: "250+(0.02*(value-5000))",
  //     },
  //     {
  //       valueOfProperty: "20000",
  //       courtFees: "250+(0.03*(value-20000))",
  //     },
  //   ],
  // },
  {
    state: "Uttar Pradesh",
    condition: [
      { valueOfProperty: "0,5000", courtFees: "0.01*(value)" },
      {
        valueOfProperty: "5000,20000",
        courtFees: "50+(0.02*(value-5000))",
      },
      {
        valueOfProperty: "20000",
        courtFees: "250+(0.03*(value-20000))",
      },
    ],
  },
  {
    state: "Madhya Pradesh",
    condition: [
      { valueOfProperty: "0,1000", courtFees: "10" },
      {
        valueOfProperty: "1000,10000",
        courtFees: "15+(0.01*(value-1000))",
      },
      {
        valueOfProperty: "10000",
        courtFees: "1615+(0.02*(value-10000))",
      },
    ],
  },
  {
    state: "Maharashtra",
    condition: [
      { valueOfProperty: "0,10000", courtFees: "0.01*(value)" },
      {
        valueOfProperty: "10000,50000",
        courtFees: "100+(0.02*(value-10000))",
      },
      {
        valueOfProperty: "50000,100000",
        courtFees: "900+(0.03*(value-50000))",
      },
      {
        valueOfProperty: "100000",
        courtFees: "2400+(0.04*(value-100000))",
      },
    ],
  },
  {
    state: "Bihar",
    condition: [
      { valueOfProperty: "0,2000", courtFees: "20" },
      {
        valueOfProperty: "2000,10000",
        courtFees: "40",
      },
      {
        valueOfProperty: "10000,100000",
        courtFees: "50+(0.02*(value-10000))",
      },
      {
        valueOfProperty: "100000",
        courtFees: "1950+(0.03*(value-100000))",
      },
    ],
  },
  {
    state: "Rajasthan",
    condition: [
      { valueOfProperty: "0,10000", courtFees: "50" },
      {
        valueOfProperty: "10000,50000",
        courtFees: "150",
      },
      {
        valueOfProperty: "50000,100000",
        courtFees: "400",
      },
      {
        valueOfProperty: "100000,500000",
        courtFees: "600",
      },
      {
        valueOfProperty: "500000",
        courtFees: "1000",
      },
    ],
  },
  {
    state: "Gujarat",
    condition: [
      { valueOfProperty: "0,5000", courtFees: "10" },
      { valueOfProperty: "5000,50000", courtFees: "20" },
      {
        valueOfProperty: "50000,200000",
        courtFees: "150+(0.01*(value-50000))",
      },
      {
        valueOfProperty: "200000,500000",
        courtFees: "1500+(0.015*(value-200000))",
      },
      {
        valueOfProperty: "500000",
        courtFees: "7500+(0.02*(value-500000))",
      },
    ],
  },
  {
    state: "Haryana",
    condition: [
      { valueOfProperty: "0,10000", courtFees: "100" },
      {
        valueOfProperty: "10000,50000",
        courtFees: "250",
      },
      {
        valueOfProperty: "50000,100000",
        courtFees: "500",
      },
      {
        valueOfProperty: "100000,500000",
        courtFees: "1000",
      },
      {
        valueOfProperty: "500000",
        courtFees: "2000",
      },
    ],
  },
  {
    state: "Punjab and Chandigarh",
    condition: [
      { valueOfProperty: "0,5000", courtFees: "0.01*(value)" },
      {
        valueOfProperty: "5000,20000",
        courtFees: "50+(0.02*(value-5000))",
      },
      {
        valueOfProperty: "20000",
        courtFees: "250+(0.03*(value-20000))",
      },
    ],
  },
  {
    state: "Himachal Pradesh",
    condition: [
      { valueOfProperty: "0,1000", courtFees: "5" },
      { valueOfProperty: "1000,5000", courtFees: "10" },
      {
        valueOfProperty: "5000,25000",
        courtFees: "20",
      },
      {
        valueOfProperty: "25000",
        courtFees: "100+(0.01*(value-25000))",
      },
    ],
  },
  {
    state: "Uttarakhand",
    condition: [
      { valueOfProperty: "0,1000", courtFees: "20" },
      { valueOfProperty: "1000,10000", courtFees: "50" },
      {
        valueOfProperty: "10000,100000",
        courtFees: "100+(0.02*(value-10000))",
      },
      {
        valueOfProperty: "100000,500000",
        courtFees: "2100+(0.03*(value-100000))",
      },
      {
        valueOfProperty: "500000",
        courtFees: "11100+(0.04*(value-500000))",
      },
    ],
  },
];

export function calculateCourtFees(propertyValue) {
  const startingValue = 400001;
  const incrementStep = 5000;
  const initialCourtFee = 6296.8;
  const courtFeeIncrement = 48.8;

  if (propertyValue < startingValue) {
    return "Property value below starting range";
  }
  const increments = Math.floor(
    (propertyValue - startingValue) / incrementStep
  );
  const courtFee = (initialCourtFee + increments * courtFeeIncrement).toFixed(
    2
  );

  return courtFee;
}
